export interface Bonus {
  id: string
  title: string
  value: string
  desc: string
  benefit: string
  /** Accent classes keep the five bonuses inside the white / charcoal / red family */
  tagClass: string
  iconClass: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Boxing Drill Vault: 150 Coach-Ready Drills',
    value: '20',
    desc: 'A complete drill library covering stance, punches, combinations, footwork, defense, counters, pads, partner work, bags, reaction, conditioning and tactics. Every drill includes objective, setup, execution, coaching cues, common errors, correction, regression, progression and success criteria.',
    benefit: 'No need to invent another drill from scratch. Open the vault, choose the objective, coach.',
    tagClass: 'bg-accent text-white',
    iconClass: 'bg-accent-soft text-accent-dark border-accent/25',
  },
  {
    id: '02',
    title: '50 Boxing Games, Challenges & Competitive Drills',
    value: '16',
    desc: 'Technical boxing games and controlled challenges designed to make sessions more engaging without sacrificing coaching quality: accuracy challenges, reaction games, footwork challenges, range-control competitions, defensive response games, partner challenges, bag-work scoring rounds and tactical games.',
    benefit: 'More engagement. Same coaching standard.',
    tagClass: 'bg-ink text-white',
    iconClass: 'bg-olive-soft text-ink border-silver',
  },
  {
    id: '03',
    title: 'Boxing Mistakes & Corrections Encyclopedia: 100 Common Errors',
    value: '18',
    desc: 'A fast-reference coaching encyclopedia covering 100 common boxing problems. Each entry follows What You See → Why It Happens → Cue → Corrective Drill → Regression → Retest, across stance, guard, balance, punches, combinations, footwork, range, defense, counters, pads, partner work, bags, conditioning, tactics and ringcraft.',
    benefit: 'See the problem. Find the cause. Correct it.',
    tagClass: 'bg-accent-dark text-white',
    iconClass: 'bg-accent-soft text-accent-dark border-accent/25',
  },
  {
    id: '04',
    title: 'Kids, Teens & Adults Boxing Coaching Adaptation Guide',
    value: '16',
    desc: 'Adapt the same boxing objectives according to age, level, experience, group type and training context — with guidance for kids, teens, adult beginners, recreational athletes, intermediate boxers and advanced athletes. Adapt coaching language, drill duration, complexity, work/rest, repetition, partner role, decision load, conditioning, progression and safety.',
    benefit: 'Same boxing skills. The right coaching approach.',
    tagClass: 'bg-toast text-ink',
    iconClass: 'bg-cream text-graphite border-silver',
  },
  {
    id: '05',
    title: '30 Emergency & No-Prep Boxing Sessions',
    value: '16',
    desc: 'Complete sessions for the days when you need something professional immediately: no-prep sessions, limited-equipment sessions, no-bag and no-pad sessions, solo sessions, mixed-level groups, small groups, short sessions, technical reset days, conditioning days, defense sessions, footwork sessions and tactical sessions.',
    benefit: 'When planning fails, your session does not have to.',
    tagClass: 'bg-gold text-ink',
    iconClass: 'bg-gold-soft text-ink border-gold/60',
  },
]

export const bonusesTotalValue = '$86'
